import { Component, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';

import { ToggleItem } from '../../../models/toggle-item.interface';

@Component({
  selector: 'eiq-toggle-buttons',
  templateUrl: 'toggle-buttons.component.html',
  styleUrls: ['./toggle-buttons.component.scss']
})
export class ToggleButtonsComponent {
  color = input<ThemePalette>('primary');
  hideSingleSelectionIndicator = input<boolean>(true);
  testId = input<string>();
  toggleCtrl = input<FormControl>();
  toggleList = input<ToggleItem<unknown>[]>();
}
